import services from './services';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import viewPhoto from 'src/common/js/viewPhoto';

export default {
    mixins: [services],
    data() {
        return {
            submitLoding: false,
            PictureVisible: false,
            dialogVisible: false,
            equipmoney: "",
            accountmoney: "",
            dialogImageUrl: "",
            form: this.getFormData(),
            OrderData: {
                CostAccountBalance: { CostHiPrePayMoney: "", CostAccountBalance: "" },
                DiscountTemplet: {
                    CostBookPrePayMoney: 0
                }
            }
        }
    },
    props: {
        Id: {
            default: "",
        }
    },
    methods: {
        getFormData() {
            return cloneDeep({
                "OrderId": "",
                "RefundPrice": "",
                "Remark": ""
            });
        },
        submitpass() {
            this.form.OrderId = this.Id;
            this.req_submit();
        },
        getData() {
            this.req_getOrderData(this.Id)
        },
        LookPicture(Url) {
            // this.dialogImageUrl = Url;
            // this.PictureVisible = true;
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{ src: Url, id: "" }]
            });
        },
        dclose() {
            this.form = this.getFormData();
        }
    },
    computed: {
        sysSid: function() {
            return this.$store.state.sysSid;
        },
        sysSession: function() {
            return this.$store.state.sysSession;
        },
        isPayWayShow() {
            let payWay = $.trim(this.OrderData.PayWay);
            if (payWay.indexOf("3") > -1) {
                return false;
            } else if (payWay.indexOf("2") > -1) {
                return true;
            }
            return false;
        },
        isShowGxJg() {
            if ($.trim(this.OrderData.PreOrderPrice).indexOf($.trim(this.OrderData.CurrentOrderPrice)) > -1) {
                return false;
            }
            return true;
        },
        isShowTzye() {
            if (this.form.RefundPrice == 0) {
                return false;
            }
            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/components/ensureRefund/vm.js